import { RenderPdfPrescription } from '../Templar/RenderPdfPrescription';
import { GET_PRESCRIPTION_TEMPLATE } from './constants';

export type Res = RenderPdfPrescription;

export default (): Promise<Res> => {
    return fetch(GET_PRESCRIPTION_TEMPLATE).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to FETCH PRESCRIPTION TEMPLATE');
        }
    });
};
